"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAccordionToken = exports.AccordionConfig = void 0;
var react_1 = __importDefault(require("react"));
var server_1 = __importDefault(require("react-dom/server"));
var Widgets_1 = require("@CommonFrontend/Public/Widgets");
var uuid_1 = require("uuid");
var lodash_1 = require("lodash");
var accordion_css_1 = require("ContentTokens/SharedWidgetComponents/Accordion/accordion.css");
var pages_common_1 = require("@qwilr/pages-common");
var styleUtilities_1 = require("@CommonFrontend/ContentTokens/SharedWidgetComponents/Accordion/styleUtilities");
var Types_1 = require("@CommonFrontendBackend/Account/Types");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var DefaultColors_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/DefaultColors");
var additionalColors = (0, lodash_1.cloneDeep)(DefaultColors_1.GOLDILOCKS_COLORS);
exports.AccordionConfig = {
    type: "accordion",
    publicRenderHtmlString: function (props) {
        var _a;
        return server_1.default.renderToString(react_1.default.createElement(Widgets_1.Accordion, {
            id: (0, uuid_1.v4)(),
            heading: props.renderTokens(props.token.heading, {
                computeForegroundColor: function (preferredForegroundColor) {
                    if (props.style.cardStyle === "visual") {
                        return "white";
                    }
                    if (!props.style.headerBackground.on) {
                        return preferredForegroundColor;
                    }
                    return (0, pages_common_1.goldilocks)(props.style.headerBackground.color.abs, {
                        mode: "text",
                        foregroundColor: preferredForegroundColor,
                    });
                },
            }),
            body: props.renderTokens(props.token.body, {
                computeForegroundColor: function (preferredForegroundColor) {
                    var bodyColor = (0, styleUtilities_1.calculateBodyColor)(props.style);
                    if (!bodyColor) {
                        return preferredForegroundColor;
                    }
                    return (0, pages_common_1.goldilocks)(bodyColor, { mode: "text", foregroundColor: preferredForegroundColor });
                },
            }),
            backgroundImageUrl: props.token.backgroundImageUrl,
            isPrintMode: (_a = props.isPrintMode) !== null && _a !== void 0 ? _a : false,
            widgetAttributes: props.attributes,
            disableImgix: props.disableImgix,
            printOrientation: props.printOrientation,
            style: props.style,
        }));
    },
    tokenType: {},
    traits: {
        spacingShim: { className: accordion_css_1.spacingShim },
        selection: { ringBorderRadius: 8, dragHandleTop: "selection-ring" },
        styleable: {
            styleKey: "accordion",
            styleAccessKey: Types_1.StyleAccessType.Accordion,
            properties: [
                {
                    label: "Card style",
                    path: "cardStyle",
                    type: "enumerable",
                    defaultValue: "simple",
                    groupKey: "Card",
                    options: [
                        {
                            label: "Simple",
                            value: "simple",
                        },
                        {
                            label: "Visual",
                            value: "visual",
                        },
                    ],
                },
                {
                    defaultValue: false,
                    label: "Header color",
                    type: "boolean",
                    path: "headerBackground.on",
                    groupKey: "Card",
                    if: function (elementStyles) {
                        return elementStyles["cardStyle"] === "simple";
                    },
                },
                {
                    label: "Header color picker",
                    labelHidden: true,
                    path: "headerBackground.color",
                    type: "color",
                    if: function (elementStyles) {
                        return elementStyles["cardStyle"] === "simple" && elementStyles["headerBackground"]["on"];
                    },
                    variable: accordion_css_1.accordionVars.headerColor,
                    defaultValue: (0, lodash_1.cloneDeep)(DefaultColors_1.DEFAULT_WHITE),
                    groupKey: "Card",
                    hugPreviousControl: true,
                    presetColors: {
                        type: "filteredThemeColors",
                        additionalColors: (0, lodash_1.cloneDeep)(additionalColors),
                    },
                },
                {
                    label: "Background color",
                    path: "bodyBackground.on",
                    type: "boolean",
                    defaultValue: false,
                    groupKey: "Card",
                    if: function (elementStyles) {
                        return elementStyles["cardStyle"] === "simple" && elementStyles["headerBackground"]["on"];
                    },
                },
                {
                    label: "Image height",
                    path: "imageHeight",
                    type: "enumerable",
                    if: function (elementStyles) { return elementStyles["cardStyle"] === "visual"; },
                    defaultValue: "medium",
                    options: [
                        {
                            label: "S",
                            value: "small",
                            applies: [
                                {
                                    variable: accordion_css_1.accordionVars.imageHeight,
                                    value: "small",
                                },
                                {
                                    variable: accordion_css_1.accordionVars.headingTopMargin,
                                    value: "72px",
                                },
                            ],
                        },
                        {
                            label: "M",
                            value: "medium",
                            applies: [
                                {
                                    variable: accordion_css_1.accordionVars.imageHeight,
                                    value: "medium",
                                },
                                {
                                    variable: accordion_css_1.accordionVars.headingTopMargin,
                                    value: "132px",
                                },
                            ],
                        },
                        {
                            label: "L",
                            value: "large",
                            applies: [
                                {
                                    variable: accordion_css_1.accordionVars.imageHeight,
                                    value: "large",
                                },
                                {
                                    variable: accordion_css_1.accordionVars.headingTopMargin,
                                    value: "192px",
                                },
                            ],
                        },
                    ],
                    groupKey: "Card",
                },
                {
                    label: "Tint Color",
                    path: "tint.color",
                    type: "color",
                    if: function (elementStyles) { return elementStyles["cardStyle"] === "visual"; },
                    variable: accordion_css_1.accordionVars.tintColor,
                    defaultValue: (0, lodash_1.cloneDeep)(DefaultColors_1.DEFAULT_MIDNIGHT),
                    groupKey: "Card",
                    presetColors: {
                        type: "filteredThemeColors",
                        additionalColors: (0, lodash_1.cloneDeep)(additionalColors),
                    },
                },
                {
                    label: "Tint Opacity",
                    path: "tint.opacity",
                    type: "numerical",
                    if: function (elementStyles) { return elementStyles["cardStyle"] === "visual"; },
                    variable: accordion_css_1.accordionVars.tintOpacity,
                    suffix: "%",
                    min: 0,
                    max: 100,
                    withSlider: true,
                    defaultValue: 25,
                    groupKey: "Card",
                },
                {
                    label: "Button style",
                    path: "buttonStyle",
                    type: "enumerable",
                    defaultValue: "arrow",
                    options: [
                        {
                            label: "Arrow",
                            icon: icons_1.MarkerTriangle,
                            value: "arrow",
                        },
                        {
                            label: "Expand",
                            icon: icons_1.Add,
                            value: "expand",
                        },
                        {
                            label: "Text label",
                            icon: icons_1.Button,
                            value: "label",
                            if: function (elementStyles) { return elementStyles["cardStyle"] === "visual"; },
                        },
                    ],
                    groupKey: "Button",
                },
                {
                    label: "Button color",
                    path: "buttonColor",
                    type: "color",
                    variable: accordion_css_1.accordionVars.buttonColor,
                    defaultValue: {
                        themeIndex: 0,
                    },
                    groupKey: "Button",
                    presetColors: {
                        type: "filteredThemeColors",
                        additionalColors: (0, lodash_1.cloneDeep)(additionalColors),
                    },
                },
                {
                    label: "Button position",
                    path: "buttonAlignment",
                    if: function (elementStyles) { return elementStyles["cardStyle"] === "simple"; },
                    type: "enumerable",
                    defaultValue: "left",
                    options: [
                        {
                            label: "Left",
                            value: "left",
                            icon: icons_1.AccordionLeftButton,
                        },
                        {
                            label: "Right",
                            value: "right",
                            icon: icons_1.AccordionRightButton,
                        },
                    ],
                    groupKey: "Button",
                },
                {
                    label: "Expand button text",
                    path: "expandButtonText",
                    if: function (elementStyles) { return elementStyles["buttonStyle"] === "label"; },
                    type: "textLabel",
                    defaultValue: "Expand",
                    variable: accordion_css_1.accordionVars.expandButtonText,
                    groupKey: "Button",
                },
                {
                    label: "Close button text",
                    path: "closeButtonText",
                    if: function (elementStyles) { return elementStyles["buttonStyle"] === "label"; },
                    type: "textLabel",
                    defaultValue: "Collapse",
                    variable: accordion_css_1.accordionVars.closeButtonText,
                    groupKey: "Button",
                },
            ],
        },
    },
    flattenForComments: function (currentToken, flattenedTokens) {
        (0, lodash_1.flattenDeep)([currentToken.heading, currentToken.body]).forEach(function (accordionToken) {
            flattenedTokens.push(accordionToken);
        });
    },
    tokenTraversers: {
        getFlatFromListOfTokens: function (token, runFlat) {
            var _a, _b, headingToken, e_1_1, _c, _d, bodyToken, e_2_1;
            var e_1, _e, e_2, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0: return [4, token];
                    case 1:
                        _g.sent();
                        _g.label = 2;
                    case 2:
                        _g.trys.push([2, 7, 8, 9]);
                        _a = __values(runFlat(token.heading)), _b = _a.next();
                        _g.label = 3;
                    case 3:
                        if (!!_b.done) return [3, 6];
                        headingToken = _b.value;
                        return [4, headingToken];
                    case 4:
                        _g.sent();
                        _g.label = 5;
                    case 5:
                        _b = _a.next();
                        return [3, 3];
                    case 6: return [3, 9];
                    case 7:
                        e_1_1 = _g.sent();
                        e_1 = { error: e_1_1 };
                        return [3, 9];
                    case 8:
                        try {
                            if (_b && !_b.done && (_e = _a.return)) _e.call(_a);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7];
                    case 9:
                        _g.trys.push([9, 14, 15, 16]);
                        _c = __values(runFlat(token.body)), _d = _c.next();
                        _g.label = 10;
                    case 10:
                        if (!!_d.done) return [3, 13];
                        bodyToken = _d.value;
                        return [4, bodyToken];
                    case 11:
                        _g.sent();
                        _g.label = 12;
                    case 12:
                        _d = _c.next();
                        return [3, 10];
                    case 13: return [3, 16];
                    case 14:
                        e_2_1 = _g.sent();
                        e_2 = { error: e_2_1 };
                        return [3, 16];
                    case 15:
                        try {
                            if (_d && !_d.done && (_f = _c.return)) _f.call(_c);
                        }
                        finally { if (e_2) throw e_2.error; }
                        return [7];
                    case 16: return [2];
                }
            });
        },
        getTransformedTokens: function (token, aggregateTokens, unpackAndTransformFn, transformFn) {
            token.heading = unpackAndTransformFn(token.heading);
            token.body = unpackAndTransformFn(token.body);
            return __spreadArray(__spreadArray([], __read(aggregateTokens), false), __read(transformFn(token)), false);
        },
    },
};
var createAccordionToken = function (heading, body) {
    if (heading === void 0) { heading = []; }
    if (body === void 0) { body = []; }
    return {
        type: "block",
        subType: "accordion",
        heading: heading,
        body: body,
    };
};
exports.createAccordionToken = createAccordionToken;
